<template>
  <div class="wrap">
    <template v-if="!(isPureType && !removePureItem)">
      <div v-if="sizeGroupObj && !isPureType" class="wrap-item">
        <div class="wrap-item_label">{{ sizeGroupObj.label }}</div>
        <div class="wrap-item_content">
          <Radio :props="{ dataSource: sizeGroupObj, name: sizeGroupObj.name }" :isSizeGroup="true" />
        </div>
      </div>
      <div class="wrap-item">
        <div class="wrap-item_label">商品规格</div>
        <div class="wrap-item_content">
          <RuleSortBtn v-if="!isPureType" class="inline-block" :specifications.sync="specifications" />
          <SpecsValuesSort v-if="!isPureType" :specifications.sync="specifications" />
          <div v-if="removePureItem" class="inline-block" style="margin-left: 10px;">
            <el-checkbox :value="alibabaForm.pureType" :true-label="1" :false-label="0" @change="changePureType">纯商品</el-checkbox>
            <el-tooltip effect="dark" content="勾选后支持纯商品发布，商品规格信息不生效" placement="top">
              <i class="el-icon-question help-icon" />
            </el-tooltip>
          </div>
          <FormItemSpecification
            v-if="!isPureType"
            ref="formItemSpecificationRef"
            v-model="specifications"
            remarkKey="note"
            :isPlatform="true"
            :platform="platform"
            :changeToBase="alibabaFormVm.changeToBase"
            :showAuditResult="$attrs.showAuditResult"
            :auditFileList="$attrs.auditFileList"
            :imgAttr="imgAttr"
            @file-upload="handleImageUpload"
          />
        </div>
      </div>
      <div v-if="!isPureType" class="wrap-item">
        <div class="wrap-item_label">商品明细</div>
        <div class="wrap-item_content">
          <FormItemSkuList
            :baseItemId="alibabaFormVm.form.baseItemId"
            :specifications="specifications"
            :imgOnlyPreview="skuImgOnlyPreview"
            :tableCols="skuTableCols_all"
             skuOuterIdKey="skuOuterId"
            :showBindSkuOuterId="openSource !== 'shopGoods'"
            @fieldChanged="specificationsFieldChanged"
            v-model="skuList"
          >
            <template slot="skuDeliveryTimeHeaderSlot">
              <span style="color: red">*</span>预售发货时间
              <el-tooltip
                class="item"
                effect="dark"
                content="按sku设置预售，需录入预售的发货时间，默认为平台发货时效（2天内发货）"
                placement="top"
              >
                <i style="margin-left: 5px; margin-right: 5px" class="el-icon-question" />
              </el-tooltip>
            </template>
          </FormItemSkuList>
          <template v-if="alibabaFormVm.specificationsValidResult !== true">
            <div class="el-form-item__error">{{ alibabaFormVm.specificationsValidResult }}</div>
          </template>
        </div>
      </div>
      <div class="wrap-item" v-if="sizeMappingsSchema.length && !isPureType">
        <div class="wrap-item_label">尺码表</div>
        <div class="wrap-item_content">
          <StdSizeExtends ref="StdSizeExtendsRef" :specifications="specifications" :schema="sizeMappingsSchema" :sizeNameKey="sizeNameKey">
          </StdSizeExtends>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { specification_mixin } from '@/components/prod/center/components/FormItemSpecification';
import storeMixins from '../store-mixins';
import Radio from '../Radio';

import FormItemSpecification from './Specifications/FormItemSpecification.vue';
import StdSizeExtends from './StdSizeExtends.vue';
import { cloneDeep } from 'lodash';

export default {
  components: {
    Radio,
    FormItemSpecification,
    StdSizeExtends,
  },
  provide: {
    disabledSpName: true,
  },
  inject: {
    alibabaFormVm: {
      default: {}
    },
    openSource:{default:null},
    isGroupPuhuo: { // 是否组合铺货
      default: false
    },
  },
  mixins: [specification_mixin, storeMixins],
  props: ['props'],
  data() {
    return {
      isAlibaba: true,
      platform: 'alibaba',
      skuSpecificationsKey: 'skuSpecifications',
      schemaSpecifications: [],
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      self_form: {}, // 与别的平台不同，为了兼容使用规格组件，将skuList初始化到这个对象
      sizeGroupObj: null, // 尺码分组
      propsMap: {}, // 销售属性下的子属性索引
      spIndexMap: {}, // 规格下标索引，防止平台规格顺序调整，编码匹配不上
      imgAttr: {},
      sizeMappingsSchema: [],
      sizeNameKey: '',
    };
  },
  computed: {
    isPureType() {
      return this.alibabaForm.pureType;
    },
    skuTableCols_all() {
      let skuTableCols = [];
      const { quotationType, supplyType, isSupportQuickBackInventory } = this.alibabaForm || {};
      if (this.isPureType) {
        skuTableCols = [{ prop: 'skuOuterId', attrs: { label: '商家编码' } }];
      } else {
        const origin_form = JSON.parse(localStorage.getItem('_origin_form'));
        skuTableCols = [
          {
            prop: 'skuPrice',
            attrs: { label: '单价' },
            input: { type: 'number' },
            visibleFn() {
              return quotationType == '1';
            },
          },
          { prop: 'skuSupplyPrice', attrs: { label: '供货价',noRequired: true },unvisible: origin_form?.isDistribution == 0?true:false},
          {
            prop: 'skuStock',
            attrs: { label: '现货库存', 'header-tooltip': '实际在库可直接发货的库存' },
            input: {
              type: 'number',
              disabled: false,
              attrs: { precision: 0 },
            },
            disabledFn: row => {
              return row.stockType == 1;
            },
          },
          {
            prop: 'skuStockOnProcess',
            attrs: { label: '快返库存', noRequired: true, 'header-tooltip': '商品正在快返中，包括排单生产、大货在途等需预售的库存' },
            input: {
              type: 'number',
              disabled: false,
              attrs: { precision: 0 },
            },
            visibleFn() {
              return (supplyType || []).includes('2') && isSupportQuickBackInventory;
            },
          },
          { prop: 'skuOuterId', attrs: { label: '商家编码', noRequired: this.isGroupPuhuo, }, input: {type: 'text', onlyTable: true } },
        ];
      }
      if(this.openSource === 'shopGoods'){
        skuTableCols = skuTableCols.filter(item => !['skuOuterId'].includes(item.prop))
      }
      return skuTableCols;
    },
    skuTimeOptions() {
      try {
        let skuDeliveryTimeItem = (this.alibabaFormVm.schemas?.sku?.children || []).find(item => item.name === 'skuDeliveryTime');
        let options = skuDeliveryTimeItem.options.map(op => {
          return {
            label: op.displayName,
            value: op.value,
          };
        });
        return options;
      } catch (error) {
        console.log(error, '---computed_skuTimeOptions');
        return [];
      }
    },
  },
  watch: {
    props: {
      immediate: true,
      handler(v) {
        let _specifications = [];
        let imgSpes = [];
        this.imgAttr = v.imgAttr;
        const saleProp = v.dataSource;
        const propertie = saleProp.properties?.length ? saleProp.properties[0] : {};
        const isAllChecked = propertie.key === 'isWithoutPair' && propertie.value === 'false';
        let specifications = cloneDeep(this.alibabaData.specifications) || []
        const hasImgSpec = specifications.find(s => s.values.find(v => v.imageUrl))
        saleProp.children.forEach(item => {
          let valueAttributeRuleList = item._oriRules?.valueAttributeRule ? item._oriRules.valueAttributeRule.split(';') : []
          if(hasImgSpec && (hasImgSpec.name === item.label || hasImgSpec.values[0].name === item.label)) {
            valueAttributeRuleList.push('img')
          }
          let _item = {
            name: item.label,
            nameKey: item.name,
            values: [],
            options: item.options,
            properties: item.properties,
            valueAttributeRuleList,
            disabledSpName: true,
            disabled: item._oriRules?.required === 'true' || isAllChecked,
            checked: item._oriRules?.required === 'true' || isAllChecked,
          };
          if (_item.valueAttributeRuleList.includes('img') && !imgSpes.length) {
            _specifications.unshift(_item);
            imgSpes.push(_item);
          } else {
            _specifications.push(_item);
          }
        });
        this.schemaSpecifications = _specifications;

        this.initPropsMap();
        this.initSpecifications();
        this.initSelfSkuList();
        this.initSizeGroup();
        this.initSizeMapping();
      },
    },
    specifications: {
      // 监听规格信息生成规格详情列表
      handler(v) {
        this.createSkuListBySpecs(v)
        this.updateAlibabaSpecifications(v)
      },
      immediate: true,
      deep: true
    },
    skuList(v) {
      // this.valiSkuOuterId(v);
      this.updateAlibabaSkuList(v)
    },
  },
  methods: {
    // 对skuList中的预售时间设置默认2天的值
    setSkuDeliveryTimeDefault() {
      this.skuList.forEach(item => {
        if (!item.skuDeliveryTime) {
          item.skuDeliveryTime = '2';
        }
      });
    },

    // 验证规格图片
    valiSkuImgs() {
      const imgErrMsgs = this.$refs.formItemSpecificationRef?.imgErrMsgs;
      if (imgErrMsgs && Object.values(imgErrMsgs).find(err => err)) {
        this.$message.error('商品明细：规格图片大小超过限制');
        return false;
      }
      return true;
    },

    // 验证商家编码是否匹配
    valiSkuOuterId(skuList) {
      if (this.isPureType) {
        return true;
      }
      if (skuList && skuList.length) {
        if (!skuList[0].skuOuterId) {
          this.$message.error('商品明细：商家编码匹配错误，请更换类目或调整规格名数量');
          return false;
        }
        return true;
      }
      return true;
    },
    // 初始化子属性索引
    initPropsMap() {
      const map = {};
      this.props.dataSource.children.forEach(it => {
        const item = cloneDeep(it);
        map[item.label] = {
          propId: item.name,
          values: item.options,
          children: item.children,
        };
      });
      // let specifications = JSON.parse(JSON.stringify(this.alibabaData.specifications)) || [];
      let specifications = this.alibabaData?.specifications ? JSON.parse(JSON.stringify(this.alibabaData.specifications)) : [];
      // 判断是否含有自定义规格
      if (specifications.find(item => (item.nameKey+'').includes('custom_'))) {
        specifications.forEach(it => {
          const item = cloneDeep(it);
          if ((item.nameKey+'').includes('custom_')) {
            map[item.name] = {
              propId: item.nameKey,
              values: [],
              children: item.children,
            };
          }
        });
      }

      this.propsMap = map;
    },
    // 初始化规格信息的数据
    initSpecifications() {
      let canUseSpecificationsIndex = []; // 可使用的详情数据下标

      // 详情数据
      let specifications = this.alibabaData?.specifications ? JSON.parse(JSON.stringify(this.alibabaData.specifications)) : [];
      const originalSpecifications = cloneDeep(specifications);
      canUseSpecificationsIndex = originalSpecifications.map((item, index) => index); // 初始化可用下标
      this.self_form.specifications = JSON.parse(JSON.stringify(specifications));
      // 当前规格信息
      let curr_specifications = JSON.parse(JSON.stringify(this.schemaSpecifications));
      // 判断是否含有自定义规格
      // if (specifications.find(item => (item.nameKey+'').includes('custom_'))) {
      //   specifications.forEach(item => {
      //     if ((item.nameKey+'').includes('custom_')) {
      //       let valueAttributeRuleList = [];
      //       const hasNote = item.values.some(spv => spv.note);
      //       if (hasNote) valueAttributeRuleList.push('remark');
      //       curr_specifications.push({ ...item, valueAttributeRuleList, properties: [] });
      //     }
      //   });
      // }
      // 当前规格信息中未与详情数据匹配到的下表索引
      let noMatchSpIndexArr = [];
      // 对当前的规格信息遍历
      curr_specifications.forEach((element, elementIndex) => {
        const { name, properties, options } = element || {};
        if (options && options.length) {
          element.formType = 'select';
        }
        if (properties && properties.length) {
          const propertie = properties[0];
          if (propertie?.type === 'taoSirProperty') {
            element.formType = 'taoSirProperty';
          }
        }
        // name 精确匹配
        let existSpIndex = specifications.findIndex(item => item.name === name);
        // name 模糊匹配
        if (existSpIndex === -1) {
          existSpIndex = specifications.findIndex(item => item.name.includes(name) || name.includes(item.name));
        }
        // 若详情数据中有相同规格名数据
        if (existSpIndex > -1) {
          element.checked = true;
          canUseSpecificationsIndex.splice(canUseSpecificationsIndex.indexOf(existSpIndex), 1); // 可用下标-1
          let existSp = specifications[existSpIndex];
          this.spIndexMap[elementIndex] = originalSpecifications.findIndex(item => item.name === existSp.name);
          let _specification = curr_specifications[elementIndex];
          _specification.values = existSp.values.map(sv => {
            return {
              ...sv,
              name: sv.name || existSp.name,
              nameKey: sv.nameKey || existSp.nameKey,
              valueErrorMsg: ''
            };
          });
          specifications.splice(existSpIndex, 1);
        } else {
          noMatchSpIndexArr.push(elementIndex);
        }
      });
      // 未匹配的规格 --- 将详情数据剩余的数据按顺序赋给未匹配的
      noMatchSpIndexArr.forEach(index => {
        let _specification = curr_specifications[index];
        if (canUseSpecificationsIndex.length < 1) {
          // 没有可用下标了
          const { rules = {} } = _specification.ui || {};
          // if (rules.required === 'true') {
          _specification.values = [
            {
              checked: true,
              name: '',
              nameKey: '',
              orderId: 999,
              value: '无规格',
              valueKey: '',
              valueErrorMsg: ''
            },
          ];
          // } else {
          //   curr_specifications.splice(index, 1, null)
          // }
        } else {
          // 使用剩余的下标
          _specification.checked = true;
          let canUseIndex = canUseSpecificationsIndex.shift();
          const { name, nameKey, values } = originalSpecifications[canUseIndex]
          _specification.values = values.map(sv => {
            return {
              ...sv,
              name: sv.name || name,
              nameKey: sv.nameKey || nameKey,
              valueErrorMsg: ''
            };
          });
          this.spIndexMap[index] = canUseIndex;
        }
      });

      // 过滤掉不需要的规格
      this.specifications = curr_specifications.filter(item => !!item);
    },
    // 初始化skuList
    initSelfSkuList() {
      let _skuList = this.alibabaData.skuList.map(item => {
        let skus = [...item[this.skuSpecificationsKey]];
        let sortSkus = [];
        this.specifications.forEach((item, index) => {
          if (this.spIndexMap[index] === undefined) return;
          sortSkus[index] = skus[this.spIndexMap[index]];
        });
        // 过滤掉规格名没有勾选的项，不参与组合_skuid
        let _skuid = sortSkus
          .filter(skuSp => {
            if (!skuSp) return;
            const findSp =
              this.specifications.find(sp => sp.values[0].name === skuSp.name || sp.name === skuSp.name || sp.nameKey === skuSp.nameKey) ||
              {};
            return !!skuSp.valueKey && findSp.checked;
          })
          .map(({ valueKey }) => valueKey)
          .join('-');
        return {
          ...item,
          _skuid,
        };
      });
      this.self_form.skuList = _skuList;
    },
    // 初始化尺码分组
    initSizeGroup() {
      // 先找到分组的配置对象
      this.props.dataSource.children.forEach(item => {
        item.children &&
          item.children.forEach(citem => {
            if (citem.name.indexOf('sizeGroup') > -1) {
              this.sizeGroupObj = citem;
            }
          });
      });
    },
    // 初始化尺码表
    initSizeMapping() {
      const sizeMapping = this.alibabaFormVm.schemas?.sizeMapping || {};
      this.sizeMappingsSchema = (sizeMapping.children || []).filter(item => item.name.startsWith('sizeMapping_'));
      const noSizeMappings = (sizeMapping.children || []).filter(item => !item.name.startsWith('sizeMapping_'));
      let sizeNameKey = 'p-20509';
      if (noSizeMappings.length == 1) {
        sizeNameKey = noSizeMappings[0].name;
      }
      this.sizeNameKey = sizeNameKey;
    },
    // 获取相关数据
    method_getData() {
      let isGroup = 0;
      // if (!this.valiSkuOuterId(this.skuList)) {
      //   return false;
      // }
      if (!this.valiSkuImgs()) {
        return false;
      }
      if (!this.validateSpecifications()) {
        return false;
      } else {
        if (this.isPureType) {
          return [[], [], {}, 0];
        }
        let [specifications, skuList] = this.getSpecificationData();

        let sizeGroup = {}; // 尺码分组后端所需
        if (this.sizeGroupObj) {
          isGroup = 1;
          // 若尺码分组存在
          // 获取当前所选的尺码分组
          const sizeGroupVal = this.alibabaForm[this.sizeGroupObj.name];
          if (!sizeGroupVal) {
            this.$message.error(`请选择${this.sizeGroupObj.label}`);
            return false;
          } else {
            // 根据所选分组得到其下的所有选项值
            for (const propName in this.propsMap) {
              if (this.propsMap[propName].propId === this.sizeGroupObj.parentName) {
                this.propsMap[propName].values = this.propsMap[propName].children
                  .find(i => /sizeValue$/.test(i.name))
                  .children.find(i => i.name.indexOf(sizeGroupVal) > -1).options;
              }
            }
          }
        }
        const stdSizeExtendsData = this.$refs?.StdSizeExtendsRef?.method_getStdSizeData() || {};
        // 处理specifications中的values值，将propsMap中的value一一对应，若没有对应的，从-2开始自减作为自定义的value
        let _valueId = -2;
        specifications = specifications.filter(sp => sp.checked);
        specifications.forEach(sp => {
          const options = this.propsMap[sp.name]?.values || [];
          const propId = this.propsMap[sp.name].propId.replace(/^p-/, '').replace(/^custom_/, '');
          sp.values.forEach(spv => {
            spv.valueKey = spv.valueKey || spv.value
            const existOption = options.find(op => (op?.displayName || '') == spv.value);
            if (existOption && parseInt(existOption.value) > 0) {
              spv.propValueId = existOption.value;
            } else {
              spv.propValueId = _valueId--;
            }
            if (stdSizeExtendsData[spv.value]) {
              spv.extendValues = { ...stdSizeExtendsData[spv.value] };
            }
            spv.propId = propId;
            delete spv.valueErrorMsg
          });
          delete sp.formType;
          delete sp.options;
          delete sp.properties;
          delete sp.valueAttributeRuleList;
          delete sp.disabled;
          delete sp.checked;
        });

        // skuList中的skuSpecifications也需要加入propValueId, propId
        skuList.forEach(sku => {
          sku.skuSpecifications.forEach((skuSp, skuSpIndex) => {
            skuSp.valueKey = skuSp.valueKey || skuSp.value
            if (skuSpIndex === 0) {
              // 取第一规格的图片赋给sku外层
              sku.imageUrl = skuSp.imageUrl;
            }
            const _spItem = specifications.find(item => item.name === skuSp.name)?.values.find(item => item.value === skuSp.value)
            if (_spItem) {
              skuSp.propId = _spItem.propId
              skuSp.propValueId = _spItem.propValueId
            }
          });
          const needSkuFieldDescriptorList = ['skuPrice','skuDeliveryTime', 'skuSupplyPrice', 'skuStock', 'skuStockOnProcess', 'skuOuterId'];
          sku.skuFieldDescriptorList = sku.skuFieldDescriptorList || [];
          sku.skuFieldDescriptorList.forEach(skuField => {
            skuField.defaultValue = sku[skuField.name]  === undefined ? '' : sku[skuField.name];
            delete sku[skuField.name];
          });
          needSkuFieldDescriptorList.forEach(field => {
            if (!sku.skuFieldDescriptorList.some(sku => sku.name === field)) {
              sku.skuFieldDescriptorList.push({
                name: field,
                defaultValue: sku[field] === undefined ? '' : sku[field],
              });
              delete sku[field];
            }
          });
        });
        return [specifications, skuList, sizeGroup, isGroup];
      }
    },
    specificationsFieldChanged() {
      this.$emit('fieldChanged');
    },
    handleImageUpload(v) {
      this.$emit('file-upload', v);
    },
    changePureType(val) {
      this.updateAlibabaForm({ pureType: val });
    },
  },
};
</script>

<style lang="scss" scoped>
.help-icon {
  margin: -2px 5px 0;
  font-size: 14px;
}
.wrap {
  .wrap-item {
    display: flex;
    .wrap-item_label {
      width: 12%;
      font-size: 12px;
      padding-right: 6px;
      text-align: right;
      flex-shrink: 0;

      &::before {
        content: '*';
        color: #f56c6c;
        margin-right: 4px;
        box-sizing: border-box;
      }
    }
    .wrap-item_content {
      flex: 1;
      overflow-x: hidden;
    }
  }
  .wrap-item + .wrap-item {
    margin-top: 20px;
  }
}
</style>